<template>
	<div>
		<b-container fluid class="margin-top-header">
			<v-section-white>
				<b-col cols="12" md="10" offset-md="1" >
					<h1 class="text-macal text-center mt-4">
						<b class="text-yellow">¡Felicidades!</b><br />
						<b>Tienes tu crédito pre-aprobado</b>
					</h1>
					<h4 class="mt-4 pl-2 text-macal border-bottom-macal">{{customer.name}}, ¡Hemos recibido tu solicitud!</h4>
					<p class="py-2">Dentro de poco nos contactaremos contigo para finalizar el proceso.</p>
					<b-row>
						<b-col cols="12" md="6" offset-md="3" class="border-yellow" style="border-radius: 0.3rem !important">
							<b-table-simple borderless class="text-center mt-3">
								<b-tr>
									<b-td class="py-0 text-yellow border-bottom-yellow text-right" >
										<h3><b>{{simulation.obj.DatosSimulacion[0].Plazo}} cuotas de</b></h3>
									</b-td>
									<b-td class="py-0 text-macal text-left text-middle" rowspan="2">
										<h1 class="display-4"><b>$ {{simulation.obj.DatosSimulacion[0].ValorCuota | numberFormat}}</b></h1>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="py-0 text-yellow text-right">
										<h5>CAE: {{simulation.obj.DatosSimulacion[0].CAE | numberFormat}}%</h5>
									</b-td>
								</b-tr>
							</b-table-simple>
						</b-col>
						<b-col cols="12" md="6" offset-md="3" class="text-center">
							<div style="margin-top: -10px;">
								<small class="p-2 border-yellow bg-cream" style="border-radius: 0.3rem">Valor Crédito: ${{simulation.obj.DatosSimulacion[0].CostoTotalCredito|numberFormat}} / Valor Pie: ${{simulation.obj.PieCredito|numberFormat}}</small>
							</div>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="12" md="10" offset-md="1" >
					<b-row v-if="others">
						<b-col cols="12">
							<h1 class="mt-4 section-subheader text-macal border-bottom-macal">Otros escenarios de financiamiento</h1>
						</b-col>
						<b-col cols="12" md="10" offset-md="1">
							<b-card-group deck class="mt-4">
								<b-card v-for="other in simulation.obj.DatosSimulacion" :key="other.Plazo" no-body class="mb-2 text-center border-yellow" border-variant="light">
									<b-table-simple v-if="other.Plazo != 60"  borderless class="text-center mt-4">
										<b-tr>
											<b-td class="py-0 text-macal" >
												<div class="border-bottom-macal" >
													<h5><b>{{other.Plazo}} Cuotas</b></h5>
												</div>
											</b-td>
										</b-tr>
										<b-tr>
											<b-td class="text-yellow">
												<h3 class="mb-0">
													<b>$ {{other.ValorCuota | numberFormat}}</b>
												</h3>
												CAE: {{new Intl.NumberFormat("es-CL").format(other.CAE)}}%
											</b-td>
										</b-tr>
									</b-table-simple>
									<b-card-footer class="bg-none no-border">
										<small>Valor Crédito: ${{other.CostoTotalCredito|numberFormat}}</small><br />
										<small>Valor Pie: ${{other.Pie|numberFormat}}</small>
									</b-card-footer>
								</b-card>
							</b-card-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" class="text-center mt-5">
							<p>¡Ahora sólo escoge tu vehículo e inscríbete al Remate!</p>
							<b-button size="lg" class="my-3 pl-5 pr-5" variant="outline-macal" @click="backToFront" >Ver oferta vehículos</b-button>
							<p><small>Cualquier duda o consulta a <a href="mailto:financiamiento@macal.cl">financiamiento@macal.cl</a></small></p>
						</b-col>
					</b-row>
					<!-- <b-row class="mt-5" v-if="simulation.legal.length > 0">
						<b-col v-if="simulation.legal.length > 0" class="mt-3" cols="12">
							<small>{{simulation.legal[2]}}</small><br />
							<small>{{simulation.legal[1]}}</small>
						</b-col>
					</b-row> -->
				</b-col>
			</v-section-white>
		</b-container>
	</div>
</template>
<script>
  import SectionWhite from "../../../components/section-white";
  export default {
    name: 'financing-success',
    components: {
		'v-section-white': SectionWhite,
	},
	props: {
        customer:{
            rut: {default: null},
            name: {default: null},
            lastnameFather: {default: null},
            lastnameMother: {default: null},
            phone: {default: null},
            email: {default: null},
            rent: {default: null},
            amount: {default: null},
            foot: {default: null},
            contact: {default: null}
        },
		simulation: {
		}
    },
	data (){
		return{
			amount: "",
			due: 60,
			loading: false,
			color: "#E4610C",
			state: null,
			others: [],
			final_simulation: {
				cae: {default: null},
				total: {default: null},
				amount: {default: null},
				due: {default: null},
				legal: {type: Array}
			}
		}
	},
	mounted() {
	},
	methods:{
		backToFront(){
			this.$router.push({ name: 'vehicles-buy', params: {customer: this.customer}});
		},
	},
	watch: {
		price: {
			handler: function() {
			}
		}
	}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>